<script setup lang="ts">
import { DgrIcon } from '@stockmarkteam/donguri-ui';

interface Props {
  placeholder?: string;
  keepFill?: boolean;
}

withDefaults(defineProps<Props>(), {
  placeholder: '検索…',
  keepFill: true,
});

const query = defineModel<string>({ type: String, default: '' });

const emit = defineEmits<{
  'on-search-query': [query: string];
  'on-focus': [];
}>();

let isComposing = false;
const onCompositionStart = () => {
  isComposing = true;
};
const onCompositionEnd = () => {
  isComposing = false;
};

const onKeyDown = (event: KeyboardEvent) => {
  if (isComposing) return;

  if (event.key === 'Enter') {
    event.preventDefault();
    emit('on-search-query', query.value);
  }
};
</script>

<template>
  <div class="m-search-bar">
    <DgrIcon
      size="small"
      name="search"
      class="m-search-icon"
      :keep-fill="keepFill"
    />
    <input
      class="m-query"
      @compositionstart="onCompositionStart"
      @compositionend="onCompositionEnd"
      @keydown="onKeyDown"
      @focus="emit('on-focus')"
      v-model="query"
      :placeholder="placeholder"
    />
  </div>
</template>
<style lang="scss" scoped>
.m-search-bar {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;

  .m-search-icon {
    position: relative;
    left: 10px;
  }

  .m-query {
    width: 100%;
    background: #ffffff;
    border: 1px solid $color-gray400;
    box-sizing: border-box;
    border-radius: 4px;
    outline: none;
    margin-left: -16px;
    padding-left: 34px;
  }
}

::placeholder {
  font-size: 14px;
  line-height: 38px;
  color: $color-gray600;
}
</style>
